import { BAND_PATHS } from "Bands/router";
import { IBaseBandSetting, IGuestlistTicketAndPassParams } from "Bands/types";
import { useBandRoute } from "Bands/utils";
import { FC, useMemo, useState } from "react";

import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons, IAPIError } from "shared/types";

import { getFields } from "./formData";

interface TicketAndPassesFormProps {
  ticketAndPassTypes: IBaseBandSetting[];
  defaultValues?: IGuestlistTicketAndPassParams;
  buttons?: IFormButtons;
  handleSubmit: (data: IGuestlistTicketAndPassParams) => void;
  apiStatus?: IAPIState | null;
  error?: string | boolean;
  apiError?: IAPIError | null;
  submitMode?: "isDirty";
  disableType?: boolean;
  resetForm?: boolean;
}

export const TicketAndPassesForm: FC<TicketAndPassesFormProps> = ({
  ticketAndPassTypes,
  defaultValues,
  buttons,
  handleSubmit,
  apiStatus,
  apiError,
  error,
  submitMode,
  disableType,
  resetForm,
}) => {
  const { pushRoute } = useBandRoute();

  const [isUnlimited, setUnlimited] = useState(!!defaultValues?.isUnlimited);

  const options = useMemo(
    () =>
      ticketAndPassTypes.map(({ id, label }) => ({
        value: id,
        label,
      })),
    [ticketAndPassTypes]
  );

  const fields = useMemo(
    () =>
      getFields({
        disableType,
        disableTicketsTotal: isUnlimited,
        ticketAndPassTypes: options,
        manageTicketAndPassTypes: () => pushRoute(BAND_PATHS.EDIT_BAND_SETTINGS_EVENT),
        handleChangeUnlimited: setUnlimited,
      }),
    [isUnlimited, options, pushRoute, disableType]
  );

  const handleSubmitAndClearState = (data: IGuestlistTicketAndPassParams) => {
    handleSubmit(data);
    setUnlimited(false);
  };

  return (
    <FormBuilder
      resetForm={resetForm}
      submitMode={submitMode}
      fields={fields}
      onSubmit={handleSubmitAndClearState}
      defaultValues={defaultValues}
      buttons={buttons}
      isSubmitting={apiStatus === IAPIState.pending}
      apiErrorMessage={error}
      apiError={apiError}
      style={{
        gridTemplateColumns: "1fr 1fr 1fr",
        mobile: {
          gridTemplateColumns: "1fr 1fr",
        },
      }}
    />
  );
};
